import axios from 'axios';
import { getStorage, setStorage } from './utils/storage';
import * as jose from 'jose';
import ReactSubscribable from './base/ReactSubscribable';
import { browserSupportsWebAuthn, platformAuthenticatorIsAvailable } from '@simplewebauthn/browser';
import SessionService from '../../SessionService';

import { 
    AUTHENTICATION_SERVER_URL,
    ACCESS_TOKEN_KEY,
    REFRESH_TOKEN_KEY,
    AUTHENTICATION_TOKEN_KEY,
    TOKENS_KEY
} from '../../configuration';
import { isIPhone } from '../../Utils';
import { fromJS } from 'immutable';



const jwt = {
    decode: (token) => {
        return jose.decodeJwt(token);
    }
}

class AuthenticationService extends ReactSubscribable {

    authenticationServer = AUTHENTICATION_SERVER_URL;
    accessToken = '';
    refreshToken = '';
    authenticationToken = '';
    authenticated = false;
    reactSubscribers = [];
    tokenPrefix = '';
    isPWA = false;
    supportsWebAuthn = false;

    state = {
        communicationMethod: 'none',
        authenticationMethod: '',
        setupRequired: false,
        authenticated: false,
        tokens: [],
        userInfo: null
    }

    addTokenPrefix(token) {
        let prefixedToken = this.tokenPrefix + token;
        return prefixedToken;
    }

    registerAsPWA() {
        if(this.isPWA) {
            return true;
        }
        if(isIPhone(navigator?.userAgent || "")) {
            this.tokenPrefix = 'pwa-';
            this.isPWA = true;
            setStorage('isPWA', true);
            this.state.isPWA = this.isPWA;
            this.updateState({ isPWA: this.isPWA });
        }
    }


    loadJWTTokenFromStorage(tokenName) {
       let token = getStorage(tokenName);
       if(token) {
            let decodedToken = jwt.decode(token);
            let timeNow = Math.round(Date.now() / 1000) + 30;
            if(decodedToken.exp > timeNow) {
                return token;
            } else {
                setStorage(tokenName, null);
            }
       }
       return null;
    }

    constructor() {
        super();


        if(window.location.search.includes('session=true')) {
            sessionStorage.setItem('useSession', 'true');
        }
        
        if(typeof window !== 'undefined'){
            this.supportsWebAuthn = browserSupportsWebAuthn();
            if(this.isPWACheck()) {
                this.tokenPrefix = 'pwa-';
                this.isPWA = true;
            }

            (async () => {  
                try {
                    let existingTokenOnCookieResponse = await axios.get(`${this.authenticationServer}/get-token-from-cookie`, {
                        credentials: 'include'
                    });
                    this.processSuccessfullAuthenticationResponse(existingTokenOnCookieResponse);
                    
                } catch (error) {
                    
                }
            })();
            // /V3/get-token-from-cookie
          
       

            this.accessToken = this.loadJWTTokenFromStorage(this.addTokenPrefix(ACCESS_TOKEN_KEY));
            this.refreshToken = this.loadJWTTokenFromStorage(this.addTokenPrefix(REFRESH_TOKEN_KEY));
            this.authenticationToken = this.loadJWTTokenFromStorage(this.addTokenPrefix(AUTHENTICATION_TOKEN_KEY));

            
            
            this.tokens = getStorage(this.addTokenPrefix(TOKENS_KEY));
            this.tokens = this.tokens ? JSON.parse(this.tokens) : [];

            if(this.authenticationToken) {
                let [authenticationMethod, setupRequired, communicationMethod] = this.getAuthenticationMethod(this.authenticationToken);
                this.state.authenticationToken = this.authenticationToken;
                this.state.authenticationMethod = authenticationMethod;
                this.state.setupRequired = setupRequired;
                this.state.communicationMethod = communicationMethod;
                let decodedAuthenticationToken = jwt.decode(this.authenticationToken);
                console.log("decodedAuthenticationToken", decodedAuthenticationToken);
            }

            

            this.state.tokens = this.tokens;
            this.state.progressive = this.tokenPrefix === 'pwa-';
            this.state.supportsWebAuthn = this.supportsWebAuthn;

            console.log("this.tokens", this.tokens);

            this.state.hasPasskey = (this.tokens || []).some(token => token && token.t == 'passkey');
            console.log("this.state.hasPasskey", this.state.hasPasskey);
        }
    }

    isPWACheck() {
        const mqStandAlone = '(display-mode: standalone)';
        let navigatorStandalone = !!navigator?.standalone;
        console.log("navigator standalone", navigatorStandalone);
        if(navigatorStandalone) {
            console.log("navigator standalone", navigatorStandalone);
        }
        if(
            navigatorStandalone ||
            window.matchMedia(mqStandAlone).matches
        ) {
            console.log("show return true on standalone");
            return true;
        }
        return false;
    }
    

    getAuthenticationMethod(authenticationToken) {
        if(!authenticationToken) {
            return ['',false];
        }
        let decodedToken = jwt.decode(authenticationToken);
        return [decodedToken.authenticationMethod, decodedToken.setupRequired, decodedToken.communicationMethod];
    }

    setOrDefault(value, defaultValue) {
        return value || defaultValue;
    }

    saveSuccessfullAuthenticationResponse(response) {
        this.accessToken = this.setOrDefault(response.data.accessToken, this.accessToken);
        this.refreshToken = this.setOrDefault(response.data.refreshToken, this.refreshToken);
        this.authenticationToken = this.setOrDefault(response.data.authenticationToken, this.authenticationToken);
        if(response.data.accessToken) {
            this.authenticationToken = '';
        }
        
        let tokens = this.tokens;
        let newTokens = response.data.tokens || [];
        newTokens = newTokens.map(token => typeof token === 'string' ? JSON.parse(token) : token);
        newTokens.forEach(token => {
            let existingToken = tokens.find(t => t.t == token.t && token.uid == t.uid );
            if(existingToken) {
                // remove existing first
                tokens = tokens.filter(t => t != existingToken);
            }
            tokens.push(token);
        });
        // tokens = tokens.concat(newTokens);
        this.tokens = tokens;

        setStorage(this.addTokenPrefix(ACCESS_TOKEN_KEY), this.accessToken);
        setStorage(this.addTokenPrefix(REFRESH_TOKEN_KEY), this.refreshToken);
        setStorage(this.addTokenPrefix(AUTHENTICATION_TOKEN_KEY), this.authenticationToken);
        setStorage(this.addTokenPrefix(TOKENS_KEY), JSON.stringify(tokens));

        let decodedAccessToken = undefined;
        if(this.accessToken) {
            decodedAccessToken = jwt.decode(this.accessToken);
        }

        let decodedAuthenticationToken = undefined;
        if(this.authenticationToken) {
            decodedAuthenticationToken = jwt.decode(this.authenticationToken);
        }

        return {
            decodedAccessToken: decodedAccessToken,
            decodedAuthenticationToken: decodedAuthenticationToken,
            tokens: tokens
        }
    }
    
    processSuccessfullAuthenticationResponse(response) {
       
        let { decodedAccessToken, decodedAuthenticationToken, tokens } = this.saveSuccessfullAuthenticationResponse(response);
        let [authenticationMethod, setupRequired, communicationMethod] = this.getAuthenticationMethod(this.authenticationToken);
        this.updateState({ 
            accessToken: decodedAccessToken,    
            authenticationToken: decodedAuthenticationToken,
            authenticated: !!(this.accessToken || this.refreshToken),
            authenticationMethod: authenticationMethod,
            setupRequired: setupRequired,
            communicationMethod: communicationMethod,
            tokens: tokens,
            hasPasskey: (this.tokens || []).some(token => token && token.t == 'passkey'),
            has2FARemembered: (this.tokens || []).some(token => token && token.t == 'totp-remember')
        

        });
    }

    processFailedfullAuthenticationResponse({ wrongInput = false } = {}) {
        let [authenticationMethod, setupRequired, communicationMethod] = this.getAuthenticationMethod(this.authenticationToken);
        this.updateState({ 
            authenticated:  false,
            authenticationMethod: authenticationMethod,
            setupRequired: setupRequired,
            communicationMethod: communicationMethod,
            error: wrongInput ? 'U heeft een foutieve combinatie van gebruikersnaam en wachtwoord ingevuld.' : null
        });
    }

    async getTokens() {
        return this.tokens;
    }

    async login({ email = '', password = ''}) {

        let knownAuthorization = await this.getAuthorizationToken();
        let config = {
            headers: {
                'X-Tab-Id': SessionService.getClientId()
            },
            credentials: 'include'
        };
        if(knownAuthorization) {
            config.headers['Authorization'] = `Bearer ${knownAuthorization}`;
            
        }

        try {
            let response = await axios.post(`${this.authenticationServer}/login`, {
                email,
                password
            }, config);
            this.processSuccessfullAuthenticationResponse(response);
        
            return true;
        } catch(e) {
            console.error("error", e);
            this.processFailedfullAuthenticationResponse({ wrongInput: e.response && e.response.status == 401});
        }
    }


    async getAccessToken() {
        let hasAccessToken = !!this.accessToken;
        let hasRefreshToken = !!this.refreshToken;

        let accessToken = this.accessToken;
        let refreshToken = this.refreshToken;

        if(hasAccessToken) {
            let decodedAccessToken = jose.decodeJwt(accessToken);
            let accessTokenExpired = decodedAccessToken.exp < ((Date.now() / 1000) + 30);
            if(accessTokenExpired && hasRefreshToken) {
                let decodedRefreshToken = jose.decodeJwt(refreshToken);
                let refreshTokenExpired = decodedRefreshToken.exp < ((Date.now() / 1000) + 30);
                if(!refreshTokenExpired) {
                    await this.renewToken();
                    await this.checkLogin();
                } else {
                    throw new Error("Access token expired");
                }
                
            } else if(!accessTokenExpired) {
                await this.checkLogin();
            } else {
                throw new Error("Access token expired");
            }
        } else {
            throw new Error("Access token not present");
        } 

        return this.accessToken;
    }

    async getAuthenticationToken() {
        return this.authenticationToken
    }

    async getAuthorizationToken() {
        await this.removeExpiredTokens();

        if(this.authenticationToken && !this.accessToken && !this.refreshToken) {
            return this.authenticationToken;
        }

        if(!this.accessToken && !this.refreshToken) {
            this.updateState({ authenticated: false });
            return null;
        }

        if(!this.accessToken && this.refreshToken) {
            let loggedIn = await this.renewToken();
            this.updateState({ authenticated: loggedIn });
            return this.accessToken;
        }

        let accessToken = this.accessToken;
        let authenticationToken = this.authenticationToken;

        return accessToken || authenticationToken;
    }

    async checkAccessToken() {

    }

    

    async checkCredentials() {
        try {
            let hasAccessToken = !!this.accessToken;
            let hasRefreshToken = !!this.refreshToken;

            let accessToken = this.accessToken;
            let refreshToken = this.refreshToken;

            


            if(hasAccessToken) {
                let decodedAccessToken = jwt.decode(accessToken);
                let accessTokenExpired = decodedAccessToken.exp < ((Date.now() / 1000) + 30);
                if(accessTokenExpired && hasRefreshToken) {
                    let decodedRefreshToken = jwt.decode(refreshToken);
                    let refreshTokenExpired = decodedRefreshToken.exp < ((Date.now() / 1000) + 30);
                    if(!refreshTokenExpired) {
                        await this.renewToken();
                        await this.checkLogin();
                    } else {
                        // throw new Error("Access token expired");
                        this.processFailedfullAuthenticationResponse();
                    }
                    
                } else if(!accessTokenExpired) {
                    await this.checkLogin();
                } else {
                    // throw new Error("Access token expired");
                    this.processFailedfullAuthenticationResponse();
                }
            } else {

                if(hasRefreshToken) {
                    let decodedRefreshToken = jwt.decode(refreshToken);
                    let refreshTokenExpired = decodedRefreshToken.exp < ((Date.now() / 1000) + 30);
                    if(!refreshTokenExpired) {
                        await this.renewToken();
                        await this.checkLogin();
                    } else {
                        // throw new Error("Access token expired");
                        this.processFailedfullAuthenticationResponse();
                    }
                } else {
                    // throw new Error("Access token expired");
                    this.processFailedfullAuthenticationResponse();
                }

                // throw new Error("Access token expired");
                this.processFailedfullAuthenticationResponse();
            }
        } catch(e) {
            console.error("error", e);

            let statusCode = e?.response?.status;
            if(statusCode === 401) {
                this.removeExpiredTokens();
                this.updateState({ authenticated: false });
            }

            this.processFailedfullAuthenticationResponse();
        }

    }

    async getResourceTokenQueryString() {
        let accessToken = await this.getAccessToken();
        let config = {
            headers: {
                'X-Tab-Id': SessionService.getClientId()
            },
            credentials: 'include'
        };
        if(accessToken) {
            config.headers['Authorization'] = `Bearer ${accessToken}`;
        }
        let response = await axios.post(`${this.authenticationServer}/request-resource-token`,{}, config);
        return response?.data?.resourceToken
    }

    async checkLogin() {

        await this.removeExpiredTokens();
        if(!this.accessToken && !this.refreshToken) {
            this.updateState({ authenticated: false });
            return false;
        }
        if(!this.accessToken && this.refreshToken) {
            let loggedIn = await this.renewToken();
            this.updateState({ authenticated: loggedIn });
            return loggedIn;
        }
        if(this.accessToken) {
            let response = await axios.get(`${this.authenticationServer}/check-token`, {
                headers: {
                    Authorization: `Bearer ${this.accessToken}`,
                    'X-Tab-Id': SessionService.getClientId()
                },
                credentials: 'include'
            });
            this.updateState({ authenticated: true });
            return true;
        }
        this.updateState({ authenticated: false });
        return false;

    
    }

    async checkLoginSignedToken(signedToken) {
        try  { 
            let knownAuthorization = await this.getAuthorizationToken();
            console.log("knownAuthorization", knownAuthorization);
            let config = {
                headers: {
                    'X-Tab-Id': SessionService.getClientId()
                },
                credentials: 'include'
            };  
            if(knownAuthorization) {
                config.headers['Authorization'] = `Bearer ${knownAuthorization}`;
            }
    
            let response = await axios.post(`${this.authenticationServer}/check-login`, signedToken, config);
            this.saveSuccessfullAuthenticationResponse(response);
            window.location.href = "/";
            return true;
        } catch(e) {
            console.error("error", e);
            if(e?.response?.status === 401) {
                this.removeExpiredTokens();
                this.updateState({ authenticated: false });
            }
            this.processFailedfullAuthenticationResponse();
        }
    }

    async removeTokens() {
        console.log("removing tokens");
        this.accessToken = '';
        this.refreshToken = '';
        this.authenticationToken = '';
        setStorage(this.addTokenPrefix(ACCESS_TOKEN_KEY), null);
        setStorage(this.addTokenPrefix(REFRESH_TOKEN_KEY), null);
        setStorage(this.addTokenPrefix(AUTHENTICATION_TOKEN_KEY), null);
        this.updateState({ authenticated: false });
    }

    async removeSpecialTokens({ type = undefined }) {
        if(type) {
            this.tokens = this.tokens.filter(token => token.t !== type);
        } else {
            console.log("removing all tokens");
            this.tokens = [];
        }
        setStorage(this.addTokenPrefix(TOKENS_KEY), JSON.stringify(this.tokens));
        this.updateState({ 
            tokens: this.tokens,
            hasPasskey: (this.tokens || []).some(token => token && token.t == 'passkey'),
            has2FARemembered: (this.tokens || []).some(token => token && token.t == 'totp-remember')
        });
    }

    async removeCookies() {
        let response = await axios.post(`${this.authenticationServer}/remove-cookies`, {}, {
            headers: {
                'X-Tab-Id': SessionService.getClientId()
            },
            credentials: 'include'
        });
        return response.data;
    }


    async resetEverything() {
        this.removeTokens();
        this.removeSpecialTokens({ });
        await this.removeCookies();
        this.updateState({ 
            authenticated: false,
            authenticationMethod: '',
            setupRequired: false,
            communicationMethod: 'none',
            hasPasskey: (this.tokens || []).some(token => token && token.t == 'passkey'),
            has2FARemembered: (this.tokens || []).some(token => token && token.t == 'totp-remember')
        });
    }

    async logout({ onlyRemoveToken = false }) {
        let config = {
            headers: {
                'X-Tab-Id': SessionService.getClientId()
            },
            credentials: 'include'
        };

        if(onlyRemoveToken) {
            this.removeTokens();
            this.updateState({ 
                authenticationToken: null,
                authenticationMethod: '',
                setupRequired: false,
                communicationMethod: 'none',
                authenticated: false 
            });
            return;
        }

        let accessToken = await this.getAccessToken();
        if(accessToken) {
            config.headers['Authorization'] = `Bearer ${accessToken}`;
        }
        
        let response = await axios.post(`${this.authenticationServer}/logout`, {}, config);

        this.accessToken = '';
        this.refreshToken = '';
        setStorage(this.addTokenPrefix(ACCESS_TOKEN_KEY), null);
        setStorage(this.addTokenPrefix(REFRESH_TOKEN_KEY), null);
        setStorage(this.addTokenPrefix(AUTHENTICATION_TOKEN_KEY), null);
        this.updateState({ authenticated: false });
    }

    async renewToken(args = {}) {
        let { clientid, contactid, freelancerid } = args;
        let response = await axios.post(`${this.authenticationServer}/refresh-token`, {
            refreshToken: this.refreshToken,
            clientid,
            contactid,
            freelancerid
        }, {
            headers: {
                'X-Tab-Id': SessionService.getClientId()
            },
            credentials: 'include'
        });
        this.accessToken = response.data.accessToken;
        this.refreshToken = response.data.refreshToken;
        setStorage(this.addTokenPrefix(ACCESS_TOKEN_KEY), this.accessToken);
        setStorage(this.addTokenPrefix(REFRESH_TOKEN_KEY), this.refreshToken);
    }

    async isTokenExpired(token) {
        let decodedToken = jwt.decode(token);
        return decodedToken.exp < Math.round(Date.now() / 1000) + 30;
    }

    async removeExpiredTokens() {
        if(this.accessToken) {
            let accessTokenExpired = await this.isTokenExpired(this.accessToken);
            if(accessTokenExpired) {
                this.accessToken = '';
                setStorage(this.addTokenPrefix(ACCESS_TOKEN_KEY), null);
            }
        }

        if(this.refreshToken) {
            let refreshTokenExpired = await this.isTokenExpired(this.refreshToken);
            if(refreshTokenExpired) {
                this.refreshToken = '';
                setStorage(this.addTokenPrefix(REFRESH_TOKEN_KEY), null);
            }
        }

        if(this.authenticationToken) {
            let authenticationTokenExpired = await this.isTokenExpired(this.authenticationToken);
            if(authenticationTokenExpired) {
                this.authenticationToken = '';
                setStorage(this.addTokenPrefix(AUTHENTICATION_TOKEN_KEY), null);
            }
        }
    }

    async getUserInfo() {
        await this.removeExpiredTokens();
        if(!this.accessToken) {
            return null;
        }
        let authorization = await this.getAuthorizationToken(); 
        let accessToken = authorization;
        let response = await axios({
            url:`${this.authenticationServer}/userinfo`, 
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${authorization}`,
                'X-Tab-Id': SessionService.getClientId()
            },
            credentials: 'include'
        });
        let userInfo = response.data;
        this.updateState({ userInfo: fromJS(userInfo) });
        return userInfo;
    }
}

const authenticationService = new AuthenticationService()

window.authenticationService = authenticationService;

export default authenticationService;